import React from 'react';
import { noOverflow, Color } from '../../../themes/styles';
import { ILine } from '../../../global';
import { lineRowHeight } from '../../../utils';
import { useLinesContext } from '../../../contexts/Lines';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ContainerWithBorder from '../Container/Container';
import Product from '../Product/Product';
import LineSummary from './LineSummary';
import NewLineButton from '../../lines/Buttons/NewLine';
import OnboardingHelpTip from './OnboardingHelpTip';
import DividerHorizontal from '../Misc/DividerHorizontal';

const useStyles = makeStyles((theme: any) => ({
  productContainer: {
    marginTop: theme.spacing(1),
    backgroundColor: ({ greyBackground }: any) => {
      return greyBackground
        ? theme.palette.brand.greyLight
        : theme.palette.brand.white;
    },
    '& .MuiTypography-root': {
      fontWeight: 'bold',
      ...(noOverflow as object),
      cursor: 'default',
    },
  },
  productWithoutLine: { height: lineRowHeight },
  bottomDivider: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
}));

function isLineInProductBeingEdited(lines: Array<ILine>) {
  const lineBeingEdited = lines.find((line) => line.edit);
  return lineBeingEdited ? true : false;
}

function addEditMode(lines: Array<ILine>) {
  const linesUpdated = lines.map((line) => {
    if (line.editRightSide) {
      line['edit'] = true;
    }
    return line;
  });
  return linesUpdated;
}

export default function LinesForProduct({
  lines,
  product,
  isLineBeingEdited,
  anchorOpened,
  setAnchorOpened,
  handleEditActiveLineDetails,
  setLineInfoDuringEdit,
  addOrDeleteError,
  lineOnEditMode,
}) {
  const { editProductClick, isCreatingFirst3Lines } = useLinesContext();
  const classes = useStyles({
    greyBackground: anchorOpened || isLineBeingEdited,
  });
  const actions = [
    {
      name: 'Edit',
      icon: './icons/edit.svg',
      onClick: () => {
        editProductClick(product);
      },
      color: 'black',
    },
  ];

  lines = addEditMode(lines);
  const hasLineInProductBeingEdited = isLineInProductBeingEdited(lines);

  const creatingFirst3Lines = isCreatingFirst3Lines();

  return (
    <ContainerWithBorder
      className={classes.productContainer}
      border={
        creatingFirst3Lines || hasLineInProductBeingEdited
          ? Color.ORANGE_DARK
          : Color.GREEN_DEEP
      }
    >
      <OnboardingHelpTip />
      <Product
        image={product?.image}
        name={product?.name}
        actions={actions}
        lineOnEditMode={lineOnEditMode}
      />
      {lines?.map((line) => {
        return (
          <LineSummary
            key={line.id}
            line={line}
            setAnchorOpened={setAnchorOpened}
            handleEditActiveLineDetails={handleEditActiveLineDetails}
            setLineInfoDuringEdit={setLineInfoDuringEdit}
            addOrDeleteError={addOrDeleteError}
            lineOnEditMode={lineOnEditMode}
          />
        );
      })}
      <div className={classes.bottomDivider}>
        <DividerHorizontal color={Color.GREEN_DEEP} />
      </div>
      <NewLineButton productId={product?.id} lineOnEditMode={lineOnEditMode} />
    </ContainerWithBorder>
  );
}
